const loginUrlsBlocking = (pathname: string, urlList: Array<string>): boolean => urlList.map((url) => (url)).includes(pathname)

export default loginUrlsBlocking
